import { render, staticRenderFns } from "./InstructionalStatusBadge.vue?vue&type=template&id=75c99d01&scoped=true"
import script from "./InstructionalStatusBadge.vue?vue&type=script&lang=js"
export * from "./InstructionalStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./InstructionalStatusBadge.vue?vue&type=style&index=0&id=75c99d01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c99d01",
  null
  
)

export default component.exports